module.exports = createNullEvents();

function createNullEvents() {
  return {
    on: noop,
    off: noop,
    stop: noop
  };
}

function noop() { }



//////////////////
// WEBPACK FOOTER
// ./node_modules/vivagraphjs/src/Utils/nullEvents.js
// module id = 24
// module chunks = 0